import styled from 'styled-components';

import { basicSmallTextStyle, RowDetails, Text } from '@dreryk/react-components';

export const StyledPrescriptionHistoryRowDetails = styled(RowDetails)`
   ${basicSmallTextStyle};
   padding-left: 4px;
`;
StyledPrescriptionHistoryRowDetails.displayName = 'StyledPrescriptionHistoryRowDetails';

export const StyledConfidentialText = styled(Text)`
   line-height: normal;
   margin-left: 4px;
`;
StyledConfidentialText.displayName = 'StyledConfidentialText';
